//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import firebase from 'firebase/app'
import 'firebase/auth'
export default {
    name: 'LayoutDefault',

    data() {
        return {
            leftDrawerOpen: false,
            drawerLinks: [
                {
                    text: 'Inicio',
                    caption: '',
                    link: '/admin/home',
                    icon: 'home',
                },
                {
                    text: 'Restaurantes',
                    caption: '',
                    link: '/admin/restaurants',
                    icon: 'store',
                },
                {
                    text: 'Facturacion',
                    caption: '',
                    link: '/admin/invoicing',
                    icon: 'receipt_long',
                },
                {
                    text: 'Menu Builder',
                    caption: '',
                    link: '/menu-builder',
                    icon: 'handyman',
                },
            ],
        }
    },
    methods: {
        async logout() {
            firebase
                .auth()
                .signOut()
                .then(async () => {
                    await this.$store.dispatch('UserLogout')
                    this.$router.push('/login/login')
                })
                .catch(error => {
                    console.log(error)
                })
        },
    },
}
